// 板
import rlModelData from "./rlModelData";
import store from "@/store/index";
import { getEntityData } from "@/rlMxModules/operate/operateApi";
import { MxCpp, McDbPolyline, McCmColor, McGePoint3d } from "mxcad";
import {
  getPKPM_SlabData,
  getArcPoints,
} from "@/rlMxModules/Opencascad/getModelDrawData";
import { rlTextData } from "./rlTextData";
import { arePointsCollinear } from "@/rlMxModules/operate/GraphicDataCal";
import {
  checkRelationGuidData,
  isPointEqual,
} from "@/rlMxModules/operate/structural";
import { isPointsCoplanar } from "@/rlMxModules/operate/GraphicDataCal";
import { getpickstatus } from "@/api/modelingList.js";
import CreateSlab from "@/rlMxModules/operate/createSlab";
class rlSlabData extends rlModelData {
  getModel3dData = store.state.globalData.rl_wasm_module.getModel3dData;
  // wasm接口方法
  // getPKPM_SlabData = store.state.globalData.rl_wasm_module.getPKPM_SlabData;
  constructor() {
    super();
    this.componentType = "slab";
    this.points = []; // 顶点数据
    this.deviation = 0.00003;
    this.SectData = []; // 截面源数据
    this.m_sectParamData = null;
    this.VertexX = null; // 楼板轮廓点的 X 坐标
    this.VertexY = null; // 楼板轮廓点的 Y 坐标
    this.VertexZ = null; // 楼板轮廓点的 Z 坐标
    this.ParaVal = null; // 楼层默认厚度
    this.Thickness = null; // 楼板厚度,9999 表示同标准层参数
    this.cc = 0; // 错层高度

    this.RoomIsHole = 0; // 是否全洞
    this.Attribute = 2; // 默认为一般构件

    this._threeObj = null; // 三维图形对象
    this.Color = null;
    this.ModelType = "楼板";
    //   (this.rlLayer && this.rlLayer[3] && this.rlLayer[3].storey) || '#00ff66' //构件颜色
    // this.Layer = 'rlSlab' //图层名称
    this.GridsGuid = []; // 板关联的网格guid集合--用于pkpm数据导入导出
    this.gridsObjs = []; // 板关联的网格对象集合
    this.classTypeName = "rlSlab"; // 板
    this.m_groupName = "rlSlabGroup"; // 组名
    this.m_useId = null; // 板关联的用途guid
    this.m_holeArray = []; // 板洞Id集合
    this.isWasmGeted = false; // 是否已经获取wasm数据

    // 检测鉴定数据--配筋数据
    this.m_jcData = [];
    // 排查--房间命名
    this.useFunctionNames = [];
    // 同类构件中主构件的guid
    this.m_RelationGuid = null;
    // 同类构件数据--临时保存文字
    this.m_HomogeneousData = [];
    this.m_HomogeneousTextStrData = null; //同类构件中主构件的文字位置偏移
    //检查构件文字--临时保存文字
    this.checkText = null;
  }

  // 绘制同类构件文字
  drawHomogeneousData(data, isDisplay) {
    if (this.m_sectParamData.Mat != 6) {
      return;
    }
    if (!data) {
      if (this.m_HomogeneousTextStrData) {
        data = this.m_HomogeneousTextStrData;
      } else {
        return;
      }
    } else {
      this.m_HomogeneousTextStrData = data;
    }
    if (this.m_HomogeneousData && this.m_HomogeneousData.length) {
      this.eraseHomogeneousData();
    }
    const fontSize = store.state.platBtns.fontSize;
    // 计算基础数据
    const points = [];
    for (let i = 0; i < this.index2dData.length; i += 3) {
      points.push(
        new McGePoint3d(this.index2dData[i], this.index2dData[i + 1], 0)
      );
    }
    let ptCenter = this.calculateCentroid(points);
    // vertical_report_area
    if (data.vertical_report_area != null) {
      const textObj = new rlTextData();
      textObj.position = ptCenter;
      textObj.Text = "板底上排:" + data.vertical_report_area;
      textObj.fontSize = fontSize;
      textObj.textType = "配筋数据文字";
      textObj.McDbText.setxDataString("Guid", this.Guid);
      textObj.McDbText.setxDataString("classTypeName", this.classTypeName);
      textObj.draw(isDisplay);
      this.m_HomogeneousData.push(textObj.mcDbId);
    }
    // horizonta_report_area
    if (data.horizonta_report_area != null) {
      ptCenter = new McGePoint3d(ptCenter.x, ptCenter.y - (fontSize + 100), 0);
      const textObj = new rlTextData();
      textObj.position = ptCenter;
      textObj.Text = "板底下排:" + data.horizonta_report_area;
      textObj.fontSize = fontSize;
      textObj.textType = "配筋数据文字";
      textObj.McDbText.setxDataString("Guid", this.Guid);
      textObj.McDbText.setxDataString("classTypeName", this.classTypeName);
      textObj.draw(isDisplay);
      this.m_HomogeneousData.push(textObj.mcDbId);
    }
  }

  // 删除同类构件文字
  eraseHomogeneousData() {
    if (this.m_HomogeneousData && this.m_HomogeneousData.length) {
      this.m_HomogeneousData.forEach((objId) => {
        objId?.getMcDbEntity().erase();
      });
      this.m_HomogeneousData = [];
    }
  }

  //绘制检查构件文字
  async drawCheckText() {
    if (
      store.state.cadModules.rlProject_detail.businessTypePermission ===
      "investigate"
    ) {
      return;
    }
    if (this.checkText) {
      this.checkText.getMcDbEntity().erase();
    }
    let checkStatus = store.state.inspectionStore.checkStatus;
    if (!checkStatus) {
      return;
    }
    let findSlab = checkStatus.find((item) => item.guid == this.Guid);
    if (findSlab) {
      const fontSize = store.state.platBtns.fontSize;
      const isShowSlab = this.getCheckStatus(7);
      const isCheckCheckText = this.getCheckStatus(25);
      let display = isShowSlab && isCheckCheckText;
      // 计算基础数据
      const points = [];
      for (let i = 0; i < this.index2dData.length; i += 3) {
        points.push(
          new McGePoint3d(this.index2dData[i], this.index2dData[i + 1], 0)
        );
      }
      let ptCenter = this.calculateCentroid(points);

      if (findSlab.content != "") {
        const textObj = new rlTextData();
        textObj.position = ptCenter;
        textObj.Text = "板(检:" + findSlab.content + ")";
        textObj.fontSize = fontSize;
        textObj.textType = "配筋数据文字";
        textObj.McDbText.setxDataString("Guid", this.Guid);
        textObj.McDbText.setxDataString("classTypeName", this.classTypeName);
        textObj.draw(display);
        this.checkText = textObj.mcDbId;
      }
    }
  }

  //删除检查构件文字
  eraseCheckText() {
    if (this.checkText) {
      this.checkText.getMcDbEntity().erase();
    }
  }

  //根据guid获取checkbox的点击状态
  getCheckStatus(guid) {
    return store.state.displayData.rlLayerDisplay.includes(guid);
  }

  drawJcData(Rebar, Support, bShow, ProblemError) {
    if (this.m_jcData && this.m_jcData.length) {
      this.eraseJcData();
    }

    let fontSize = store.state.platBtns.fontSize * 2;
    for (const jcData of Rebar) {
      const textObj = new rlTextData();
      textObj.position = new McGePoint3d(
        jcData.position[0],
        jcData.position[1],
        0
      );
      textObj.Text = jcData.value;
      textObj.fontSize = fontSize;
      textObj.dAngle = jcData.Rotation;
      if (ProblemError && ProblemError.includes("1")) {
        textObj.color = new McCmColor(255, 0, 0);
      }
      textObj.draw(bShow);
      this.m_jcData.push(textObj.mcDbId);
    }

    for (const jcData of Support) {
      const textObj = new rlTextData();
      textObj.position = new McGePoint3d(
        jcData.position[0],
        jcData.position[1],
        0
      );
      textObj.Text = jcData.value;
      textObj.fontSize = fontSize;
      textObj.dAngle = jcData.Rotation;
      if (ProblemError && ProblemError.includes("2")) {
        textObj.color = new McCmColor(255, 0, 0);
      }
      textObj.draw(bShow);
      this.m_jcData.push(textObj.mcDbId);
    }

    store.commit("rlEntData/editEntityData", {
      Guid: this.Guid,
      classTypeName: this.classTypeName,
    });
  }
  eraseJcData() {
    if (this.m_jcData && this.m_jcData.length) {
      this.m_jcData.forEach((objId) => {
        objId?.getMcDbEntity().erase();
      });
      this.m_jcData = [];
    }
  }
  initData(obj) {
    super.initData(obj);
    this.GridsGuid = obj.GridsGuid;
    this.gridsObjs = obj.gridsObjs;

    this.VertexX = obj.VertexX;
    this.VertexY = obj.VertexY;
    this.VertexZ = obj.VertexZ;
    this.ParaVal = obj.ParaVal;
    this.Thickness = obj.Thickness;
    this.RoomIsHole = obj.RoomIsHole;
    this.Color = obj.Color;

    this.index2dData = obj.index2dData;
    this.index3dData = obj.index3dData;
    this.points = obj.points;
    this.useFunctionNames = obj.useFunctionNames ? obj.useFunctionNames : [];
    this.m_RelationGuid = obj.m_RelationGuid ? obj.m_RelationGuid : null;
    this.cc = obj.cc;
  }

  // 数据转换
  convert() {
    const groupName = this.m_sectParamData.Thickness.toString();
    if (
      !this.isWasmGeted ||
      (!this.index2dData && !this.index3dData) ||
      groupName != this.CurrtSect
    ) {
      let hasArc = false;
      let gridPts = [];
      let GridsGuidGroup = this.GridsGuid.split(",");
      let allPoints = [];
      for (let n = 0; n < GridsGuidGroup.length; n++) {
        const objGrid = getEntityData({
          classTypeName: "rlGrid",
          Guid: GridsGuidGroup[n],
        });
        if (objGrid) {
          const isArc =
            (objGrid && objGrid.m_centerJoint) ||
            (objGrid && objGrid.m_Axis && objGrid.m_Axis.IsMainAxis < 0);
          if (isArc) {
            hasArc = true;
            const stPoint = new McGePoint3d(...objGrid.m_stJoint.m_pt);
            const edPoint = new McGePoint3d(...objGrid.m_edJoint.m_pt);
            const centerPoint = new McGePoint3d(
              objGrid.centerPoint[0],
              objGrid.centerPoint[1],
              0
            );
            const dRadius = objGrid.mcDbGrid.radius;
            const points = getArcPoints(stPoint, edPoint, centerPoint, dRadius);
            const pointsStr = points
              .map((item) => `${item.x},${item.y},0`)
              .join(",");
            gridPts.push(`${GridsGuidGroup[n]}:[${pointsStr}],`);
          } else {
            let pt1 = new McGePoint3d(...objGrid.m_stJoint.m_pt);
            let pt2 = new McGePoint3d(...objGrid.m_edJoint.m_pt);
            let isPt1 = false;
            let isPt2 = false;
            for (let i = 0; i < allPoints.length; i++) {
              if (isPointEqual(allPoints[i], pt1, 0.1)) {
                isPt1 = true;
                continue;
              } else {
                let dist = allPoints[i].distanceTo(pt1);
                if (dist < 3) {
                  pt1.x = allPoints[i].x;
                  pt1.y = allPoints[i].y;
                  isPt1 = true;
                  continue;
                }
              }
              if (isPointEqual(allPoints[i], pt2, 0.1)) {
                isPt2 = true;
                continue;
              } else {
                let dist = allPoints[i].distanceTo(pt2);
                if (dist < 3) {
                  pt2.x = allPoints[i].x;
                  pt2.y = allPoints[i].y;
                  isPt2 = true;
                  continue;
                }
              }
            }
            if (!isPt1) allPoints.push(pt1);
            if (!isPt2) allPoints.push(pt2);
            gridPts.push(
              `${GridsGuidGroup[n]}:[${[pt1.x, pt1.y, 0, pt2.x, pt2.y, 0]}],`
            );
          }
        }
      }
      //判断如果有圆弧线段重新计算一下楼板轮廓
      if (hasArc) {
        let data = "";
        gridPts.forEach((item) => (data += item));
        // 获取隔墙围成的闭合区域
        // let res = await rlModules.getSlabJsonData(data);
        const createSlab = new CreateSlab();
        const ress = createSlab.getSlabJsonData(data);
        if (ress) {
          const model = JSON.parse(ress)?.Slab;
          const modelKeys = Object.keys(model);
          const modelData = Object.values(model).flat();
          for (let index = 0; index < modelData.length; index++) {
            const item = modelData[index];
            if (!modelKeys[index]) continue;
            const New2dUpView = item["2DUpView"];
            let strX = "";
            let strY = "";
            let strZ = "";
            for (let index = 0; index < New2dUpView.length - 2; index += 3) {
              strX += New2dUpView[index] + ",";
              strY += New2dUpView[index + 1] + ",";
              strZ += "0,";
            }
            if (strX != "" && strY != "" && strZ != "") {
              this.VertexX = strX;
              this.VertexY = strY;
              this.VertexZ = strZ;
              break;
            }
          }
        }
      }
      const res = getPKPM_SlabData(
        this.VertexX,
        this.VertexY,
        100,
        // this.ParaVal ? 100 : this.ParaVal,
        this.m_sectParamData.Thickness,
        this.LevelB - this.cc,
        this.Height
      );
      if (!res) return;
      this.getModelDrawData(JSON.parse(res));
      this.calculateZValue();

      // 计算基础数据
      const points = [];
      for (let i = 0; i < this.index2dData.length; i += 3) {
        points.push(
          new McGePoint3d(this.index2dData[i], this.index2dData[i + 1], 0)
        );
      }

      // 移除共线的点
      const filteredPoints = [];
      for (let i = 0; i < points.length; i++) {
        const prev = i === 0 ? points[points.length - 1] : points[i - 1];
        const curr = points[i];
        const next = i === points.length - 1 ? points[0] : points[i + 1];

        // 检查三点是否共线
        const isCollinear = arePointsCollinear(prev, curr, next);

        if (!isCollinear) {
          filteredPoints.push(curr);
        }
      }

      // 更新points数组
      points.length = 0;
      points.push(...filteredPoints);

      //points中若存在多点共线，只留下一个两端点
      const lengthDatas = [];
      for (let i = 0; i < points.length; i++) {
        let lastIndex = i + 1;
        if (i == points.length - 1) lastIndex = 0;
        const dist = points[i].distanceTo(points[lastIndex]);
        lengthDatas.push(dist);
      }
      this.OtherData.Length = lengthDatas;

      // let wasmData = JSON.parse(res);
      // let data = `{"${this.Guid}":${JSON.stringify(wasmData)}}`;
      // let data3D = this.getModel3dData(data);
      // if (!data3D) return;

      // data3D = JSON.parse(data3D)["3D"][this.Guid];
      // this.points = data3D.Points;
      // this.index3dData = {
      //   points: data3D.Points,
      //   faces: data3D["3dFaces"].map((item) => item.index).flat(),
      // };
    } else {
      if (!Array.isArray(this.index2dData)) {
        this.index2dData = this.index2dData.split(",").map(Number);
      }
    }
  }

  //根据上节点高计算三维的z值
  calculateZValue() {
    let gridIds = this.GridsGuid;
    let gridsObjs = gridIds
      .split(",")
      .map((guid) => getEntityData({ Guid: guid, classTypeName: "rlGrid" }));
    let jointDatas = []; //楼板顶点对应的节点
    for (let j = 0; j < gridsObjs.length; j++) {
      let gridObj = gridsObjs[j];
      if (gridObj && gridObj.classTypeName == "rlGrid") {
        jointDatas.push(gridObj.m_stJoint, gridObj.m_edJoint);
      }
    }
    jointDatas = [...new Set(jointDatas)];
    let pts = [];
    for (let j = 0; j < jointDatas.length; j++) {
      let jointObj = jointDatas[j];
      if (jointObj && jointObj.classTypeName == "rlJoint") {
        pts.push(
          new THREE.Vector3(
            jointObj.m_pt[0],
            jointObj.m_pt[1],
            Number(jointObj.HDiff)
          )
        );
      }
    }
    //计算pts的所有点是否在同一平面上
    const isCoplanar = isPointsCoplanar(pts);
    if (!isCoplanar) {
      return;
    }

    let slabPoints = [];
    for (let j = 0; j < this.index3dData.points.length; j += 3) {
      slabPoints.push(
        new THREE.Vector3(
          this.index3dData.points[j],
          this.index3dData.points[j + 1],
          this.index3dData.points[j + 2]
        )
      );
    }
    for (let j = 0; j < slabPoints.length; j++) {
      //若节点的x和y与pts的x和y相同，则更新该节点的z值
      let samePoint = pts.find(
        (item) =>
          Math.abs(item.x - slabPoints[j].x) < 1 &&
          Math.abs(item.y - slabPoints[j].y) < 1
      );
      if (samePoint) {
        slabPoints[j].z += samePoint.z;
      }
    }

    //将 slabPoints转为数组
    let slabPointsArray = [];
    for (let j = 0; j < slabPoints.length; j++) {
      slabPointsArray.push(slabPoints[j].x, slabPoints[j].y, slabPoints[j].z);
    }

    this.index3dData.points = slabPointsArray;
  }

  // wasm截面数据转换
  // getModelDrawData(modelData) {
  //   // this.index3dData = modelData["3D"]["3dFaces"]
  //   //   .map((item) => item.index)
  //   //   .flat();
  //   this.index2dData = modelData["2DUpView"];
  //   this.SectData = modelData["SectData"];
  //   this.OtherData = JSON.stringify(modelData);
  // }

  // 删除
  async erase() {
    await checkRelationGuidData(this.Guid, "rlSlab");
    // 删除板洞
    if (this.m_holeArray.length > 0) {
      for (const axisId of this.m_holeArray) {
        const objtmp = getEntityData({
          classTypeName: "rlSlabHole",
          Guid: axisId,
        });
        if (objtmp) objtmp.erase();
      }
    }
    // this.GridsGuid ? (this.GridsGuid = []) : "";
    // 删除用途
    if (this.m_useId) {
      const objtmp = getEntityData({
        classTypeName: "rlUse",
        Guid: this.m_useId,
      });
      if (objtmp) objtmp.erase();
    }

    for (let i = 0; i < this.gridsObjs.length; i++) {
      const item = this.gridsObjs[i];

      if (item && item.m_slabIds && item.m_slabIds.length) {
        item.m_slabIds = item.m_slabIds.filter((item) => item != this.Guid);
      }
    }
    this.eraseCheckText();
    // this.GridsID ? (this.GridsID = []) : "";
    // this.gridsObjs ? (this.gridsObjs = []) : "";
    super.erase();
  }

  myClone() {
    const newObj = new rlSlabData();
    super.cloneData(newObj);
    newObj.GridsGuid = this.GridsGuid;

    newObj.VertexX = this.VertexX;
    newObj.VertexY = this.VertexY;
    newObj.VertexZ = this.VertexZ;
    newObj.ParaVal = this.ParaVal;
    newObj.Thickness = this.Thickness;
    newObj.Color = this.Color;
    newObj.useFunctionNames = this.useFunctionNames;
    newObj.m_RelationGuid = this.m_RelationGuid;
    return newObj;
  }

  // 绘制
  draw() {
    this.convert();
    if (!this.index2dData || !this.index3dData) return;
    if (!this.isWasmGeted) this.isWasmGeted = true;

    this.m_sectGroupName = this.m_sectParamData.Thickness.toString();
    if (this.RoomIsHole) {
      this.m_sectGroupName = "";
    }
    this.CurrtSect = this.m_sectGroupName;
    //
    // super.draw();
    if (!this.member) {
      // 非点击构件生成才走数据转换
      this.convert();
    }
    if (this.mcDbId) {
      this.mcDbId.getMcDbEntity().erase();
      this.mcDbPolyline = new McDbPolyline();
    }
    MxCpp.getCurrentMxCAD().showLineWeight(true);
    this.mcDbPolyline.lineweight = 20;
    if (this.RoomIsHole) {
      this.componentType = "SlabHole";
      this.mcDbPolyline.trueColor = new McCmColor(173, 153, 153);
    } else {
      this.componentType = "slab";
      this.mcDbPolyline.trueColor = new McCmColor(
        this.Color.r,
        this.Color.g,
        this.Color.b
      );
    }
    this.mcDbPolyline.visible = store.state.displayData.slabDisplay;
    this.mcDbPolyline.setxDataString("Guid", this.Guid);
    this.mcDbPolyline.setxDataString("classTypeName", this.classTypeName);

    this.points = this.index3dData.points;
    if (this.points) {
      this.points = this.points.map((item, index) => {
        if (index % 3 === 2) {
          return item + store.state.cadModules.rlBuilding.LevelB;
        }
        return item;
      });
    }

    this.create2dModel(this.index2dData, this.mcDbPolyline);
    if (!this.index3dData) return;
    this._threeObj = this.create3dModel(
      this.points,
      Array.isArray(this.index3dData)
        ? this.index3dData
        : this.index3dData.faces
    );
    this.gridsObjs &&
      this.gridsObjs.forEach((ele) => {
        if (ele && !ele.m_slabIds.includes(this.Guid)) {
          ele.m_slabIds.push(this.Guid);
        }
      });

    if (this.m_TextObj && this.m_TextObj.mcDbId) {
      this.m_TextObj.mcDbId.getMcDbEntity().textString = this.m_sectGroupName;
    }
    this.drawCheckText();
  }

  // 返回图形源数据
  getDataBase() {
    const data = super.getDataBase();
    data["SectGuid"] = this.m_sectParamData.Guid;
    data["GridsGuid"] = this.GridsGuid;
    // if (!data.OtherData)
    data["VertexX"] = this.VertexX;
    data["VertexY"] = this.VertexY;
    data["VertexZ"] = this.VertexZ;
    data["RoomIsHole"] = this.RoomIsHole;
    data["Thickness"] = this.m_sectParamData.Thickness;
    data["Shape"] = this.Shape;
    data["useFunctionNames"] = this.useFunctionNames?.join(",");
    data["RelationGuid"] = this.m_RelationGuid;
    data["cc"] = this.cc;
    return data;
  }

  // 获取图形绘制数据--用于撤销回退
  getDrawData() {
    const data = super.getDrawData();

    data["GridsGuid"] = this.GridsGuid;
    data["VertexX"] = this.VertexX;
    data["VertexY"] = this.VertexY;
    data["VertexZ"] = this.VertexZ;
    data["RoomIsHole"] = this.RoomIsHole;
    data["Thickness"] = this.m_sectParamData.Thickness;
    data["Shape"] = this.Shape;

    data["m_holeArray"] = this.m_holeArray;
    data["useFunctionNames"] = JSON.stringify(this.useFunctionNames);
    data["RelationGuid"] = this.m_RelationGuid;
    data["cc"] = this.cc;
    return data;
  }

  // 用于撤销回退
  reDraw(obj) {
    super.reDraw(obj);

    this.GridsGuid = obj.GridsGuid;

    this.VertexX = obj.VertexX;
    this.VertexY = obj.VertexY;
    this.VertexZ = obj.VertexZ;
    this.ParaVal = obj.ParaVal;
    this.Thickness = obj.Thickness;
    this.RoomIsHole = obj.RoomIsHole;
    this.m_holeArray = obj.m_holeArray;

    this.gridsObjs = obj.GridsGuid.split(",")
      .map((guid) => getEntityData({ Guid: guid, classTypeName: "rlGrid" }))
      .filter(Boolean);
    this.useFunctionNames = JSON.parse(obj.useFunctionNames);
    this.m_RelationGuid = obj.m_RelationGuid;
  }

  calculateCentroid(points) {
    if (points.length === 0) {
      return null;
    }

    // 计算多边形的边界框
    let minX = Infinity;
    let maxX = -Infinity;
    let minY = Infinity;
    let maxY = -Infinity;
    for (const point of points) {
      minX = Math.min(minX, point.x);
      maxX = Math.max(maxX, point.x);
      minY = Math.min(minY, point.y);
      maxY = Math.max(maxY, point.y);
    }

    // 计算边界框的尺寸
    const width = maxX - minX;
    const height = maxY - minY;
    const minSize = Math.min(width, height);

    // 设置最小边距，为边界框最小尺寸的10%
    const minMargin = minSize * 0.1;

    // 使用多边形面积加权的方法计算重心
    let area = 0;
    let centroidX = 0;
    let centroidY = 0;

    for (let i = 0; i < points.length; i++) {
      const j = (i + 1) % points.length;
      const p1 = points[i];
      const p2 = points[j];

      const triangleArea = p1.x * p2.y - p2.x * p1.y;
      area += triangleArea;
      centroidX += (p1.x + p2.x) * triangleArea;
      centroidY += (p1.y + p2.y) * triangleArea;
    }

    area = area / 2;

    if (Math.abs(area) < 1e-8) {
      // 如果面积接近0，返回边界框中心点
      return new McGePoint3d((minX + maxX) / 2, (minY + maxY) / 2, 0);
    }

    const factor = 1 / (6 * area);
    centroidX *= factor;
    centroidY *= factor;

    // 检查点是否在多边形内部且距离边缘足够远
    if (
      this.isPointInPolygonWithMargin(centroidX, centroidY, points, minMargin)
    ) {
      return new McGePoint3d(centroidX, centroidY, 0);
    }

    // 如果重心点不满足条件，在多边形内部寻找合适的点
    return this.findSafeInteriorPoint(points, minMargin);
  }

  // 在多边形内部寻找安全的点
  findSafeInteriorPoint(points, margin) {
    // 计算边界框
    let minX = Infinity,
      maxX = -Infinity;
    let minY = Infinity,
      maxY = -Infinity;

    for (const point of points) {
      minX = Math.min(minX, point.x);
      maxX = Math.max(maxX, point.x);
      minY = Math.min(minY, point.y);
      maxY = Math.max(maxY, point.y);
    }

    // 计算中心点
    const centerX = (minX + maxX) / 2;
    const centerY = (minY + maxY) / 2;

    // 从中心开始，螺旋式向外搜索
    const gridSize = margin / 2;
    let radius = 0;
    const maxRadius = Math.max(maxX - minX, maxY - minY);

    while (radius <= maxRadius) {
      // 在当前半径的圆上采样点
      for (let angle = 0; angle < Math.PI * 2; angle += Math.PI / 8) {
        const x = centerX + radius * Math.cos(angle);
        const y = centerY + radius * Math.sin(angle);

        if (this.isPointInPolygonWithMargin(x, y, points, margin)) {
          return new McGePoint3d(x, y, 0);
        }
      }

      radius += gridSize;
    }

    // 如果螺旋搜索失败，使用网格搜索作为备选方案
    const rows = 10;
    const cols = 10;
    const stepX = (maxX - minX - 2 * margin) / cols;
    const stepY = (maxY - minY - 2 * margin) / rows;

    let bestPoint = null;
    let minDistanceToCenter = Infinity;

    for (let i = 0; i <= rows; i++) {
      for (let j = 0; j <= cols; j++) {
        const x = minX + margin + j * stepX;
        const y = minY + margin + i * stepY;

        if (this.isPointInPolygonWithMargin(x, y, points, margin)) {
          // 计算到中心点的距离
          const distToCenter = Math.sqrt(
            Math.pow(x - centerX, 2) + Math.pow(y - centerY, 2)
          );

          if (distToCenter < minDistanceToCenter) {
            minDistanceToCenter = distToCenter;
            bestPoint = { x, y };
          }
        }
      }
    }

    if (bestPoint) {
      return new McGePoint3d(bestPoint.x, bestPoint.y, 0);
    }

    // 最后的备选方案：使用重心
    let centroidX = 0;
    let centroidY = 0;
    let area = 0;

    for (let i = 0; i < points.length; i++) {
      const j = (i + 1) % points.length;
      const p1 = points[i];
      const p2 = points[j];

      const triangleArea = p1.x * p2.y - p2.x * p1.y;
      area += triangleArea;
      centroidX += (p1.x + p2.x) * triangleArea;
      centroidY += (p1.y + p2.y) * triangleArea;
    }

    area = area / 2;
    if (Math.abs(area) > 1e-8) {
      const factor = 1 / (6 * area);
      centroidX *= factor;
      centroidY *= factor;

      // 如果重心在多边形内且满足边距要求，直接使用重心
      if (
        this.isPointInPolygonWithMargin(centroidX, centroidY, points, margin)
      ) {
        return new McGePoint3d(centroidX, centroidY, 0);
      }
    }

    // 最终备选：三角形重心
    return new McGePoint3d(
      (points[0].x + points[1].x + points[2].x) / 3,
      (points[0].y + points[1].y + points[2].y) / 3,
      0
    );
  }

  // 判断点是否在多边形内部且距离边缘有足够距离
  isPointInPolygonWithMargin(x, y, points, margin) {
    if (!this.isPointInPolygon(x, y, points)) return false;

    // 检查到所有边的距离
    for (let i = 0; i < points.length; i++) {
      const j = (i + 1) % points.length;
      const p1 = points[i];
      const p2 = points[j];

      // 计算点到线段的距离
      const distance = this.pointToLineDistance(x, y, p1, p2);
      if (distance < margin) return false;
    }

    return true;
  }
  // 计算点到线段的距离
  pointToLineDistance(x, y, p1, p2) {
    const A = x - p1.x;
    const B = y - p1.y;
    const C = p2.x - p1.x;
    const D = p2.y - p1.y;

    const dot = A * C + B * D;
    const lenSq = C * C + D * D;

    // 参数方程的参数
    let param = -1;
    if (lenSq !== 0) param = dot / lenSq;

    let xx, yy;

    if (param < 0) {
      xx = p1.x;
      yy = p1.y;
    } else if (param > 1) {
      xx = p2.x;
      yy = p2.y;
    } else {
      xx = p1.x + param * C;
      yy = p1.y + param * D;
    }

    const dx = x - xx;
    const dy = y - yy;

    return Math.sqrt(dx * dx + dy * dy);
  }
  // 判断点是否在多边形内部
  isPointInPolygon(x, y, points) {
    let inside = false;

    for (let i = 0, j = points.length - 1; i < points.length; j = i++) {
      const xi = points[i].x;
      const yi = points[i].y;
      const xj = points[j].x;
      const yj = points[j].y;

      // 射线法判断点是否在多边形内部
      const intersect =
        yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;

      if (intersect) inside = !inside;
    }

    return inside;
  }
}

export { rlSlabData };
